import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import {
    StyledCsvEnrichmentDescription,
    StyledCsvEnrichmentEmptyWrapper,
} from "app/pages/sales-intelligence/pages/home/containers/CSVEnrichmentContainer/styles";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";
import CSVEnrichmentButtonsView from "app/pages/sales-intelligence/pages/home/components/CSVEnrichmentCard/CSVEnrichmentButtonsView";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import GetMoreResultsSalesSolution from "app/pages/sales-intelligence/common-components/GainAccessButton/GetMoreResultsSalesSolution";

type EmptyCSVEnrichmentViewProps = {
    automationId: string;
    metadata: ViewModelMetadata;
    onUploadCsv: () => void;
};

const EmptyCSVEnrichmentView: FC<EmptyCSVEnrichmentViewProps> = ({ automationId, metadata, onUploadCsv }) => {
    const isLocked = !salesSettingsHelper.isCsvEnrichmentEnabled();

    return (
        <StyledCsvEnrichmentEmptyWrapper data-automation={`home-${automationId}-empty-state`}>
            <StyledCsvEnrichmentDescription>
                {translate("si.pages.home.card.csv-enrichment.description")}
            </StyledCsvEnrichmentDescription>

            {isLocked ? (
                <GetMoreResultsSalesSolution />
            ) : (
                <CSVEnrichmentButtonsView
                    metadata={metadata}
                    onUploadCsv={onUploadCsv}
                />
            )}
        </StyledCsvEnrichmentEmptyWrapper>
    );
};

export default EmptyCSVEnrichmentView;
